export const paymentMethods = [
  {
    id: 'payClaim',
    name: 'Pay and Claim',
    description: 'Pay with own funds first & claim later.',
    value: 'payClaim',
    default: false,
  },
  {
    id: 'vcc',
    name: 'Virtual Credit Card (VCC)',
    description: 'For digital payments only, card generated by finance.',
    value: 'vcc',
    default: true,
  },
  {
    id: 'bankTransfer',
    name: 'Bank Transfer',
    description: 'For invoice & Vendors@Gov vendors only.',
    value: 'bankTransfer',
    default: false,
  },
]

export const paymentMethodById = (id: string | undefined) => {
  return paymentMethods.find((method) => method.id === id)
}
